import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { AUTOMATION_EDIT_FORM } from "../../../constants/modal.constant";
import { useAutomationCore } from "../../../cores/automations";
import { AutomationTriggerOptions } from "../../../cores/automations/config";
import { Automation } from "../../../cores/automations/interfaces/api/get-automation";
import { useBoardCore } from "../../../cores/boards";
import { useContactCore } from "../../../cores/contacts";
import { useGlobalCore } from "../../../cores/globals";
import { useMeCore } from "../../../cores/me";
import { CheckboxWembii } from "../CheckboxWembii";

interface Props {
  automation: Automation;
}

export const AutomationRow = (props: Props) => {
  const intl = useIntl();
  const {
    automation: { id, name, active, trigger },
  } = props;
  const { turnOnModal } = useGlobalCore();
  const { company } = useMeCore();
  const { getContactTags } = useContactCore();
  const { getAutomation, putAutomation } = useAutomationCore();
  const { getBusinessBoards } = useBoardCore();

  const onClick = useCallback(() => {
    getContactTags(company?.id!);
    getBusinessBoards(company?.id!);
    turnOnModal(AUTOMATION_EDIT_FORM, true);
    getAutomation(company?.id!, id);
  }, [
    getAutomation,
    getContactTags,
    turnOnModal,
    getBusinessBoards,
    company,
    id,
  ]);

  const onUpdateAutomation = useCallback(() => {
    putAutomation(company?.id!, id, !active);
  }, [putAutomation, company, id, active]);

  const triggerOption = useMemo(
    () => AutomationTriggerOptions.find((option) => option.value === trigger),
    [trigger]
  );

  return (
    <article className="automation-card">
      <button type="button" className="automation-card__main" onClick={onClick}>
        <span className="automation-card__icon">
          <FontAwesomeIcon icon={["fas", (triggerOption?.icon || "robot") as IconName]} />
        </span>
        <span className="automation-card__content">
          <span className="automation-card__title">{name}</span>
          <span className="automation-card__trigger">
            {intl.formatMessage({ id: triggerOption?.label })}
          </span>
        </span>
      </button>

      <div className="automation-card__meta">
        <span className={active ? "automation-status is-active" : "automation-status"}>
          <span />
          {active ? "Activo" : "Pausado"}
        </span>
        <div className="automation-card__toggle" onClick={(event) => event.stopPropagation()}>
          <CheckboxWembii
            mb={false}
            checked={active}
            label={intl.formatMessage({
              id: "app.automations.automation.active",
            })}
            onChange={onUpdateAutomation}
          />
        </div>
      </div>
    </article>
  );
};
